/*
 * @Description:出入厂相关接口
 * @Author: fanwenjing
 * @LastEditors: fanwenjing
 * @Date: 2021-05-26 22:21:29
 * @LastEditTime: 2021-06-03 10:09:04
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host = "", E6_MS_TMS_BUSI_WEB = "" } = e6ModuleOrderWaybillProcessApi;
//********************* 出入厂相关接口 ****************** */

//  获取查询规则列表数据
export function ruleQueryPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/check/rule/query`,
    method: "post",
    data
  });
}
//启用禁用
export function ruleActive(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/check/rule/active`,
    method: "post",
    data
  });
}
//获取详情
export function getRuleDetail(id) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/check/rule/detail?ruleId=${id}`,
    method: "get"
  });
}
//校验
export function checkRuleUnique(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/check/rule/unique`,
    method: "post",
    data
  });
}
//保存规则设置
export function checkRuleUpdate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/check/rule/update`,
    method: "post",
    data
  });
}
